import {
  createBrowserRouter,
  createHashRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import IndexPage from "../pages";
import Home2Page from "../pages/home2";
import { Layout } from "../layouts/app";



const router = createHashRouter(
  createRoutesFromElements(
    <Route path="/" element={<Layout />}>
      <Route path="" element={<IndexPage />} />
      <Route path="home" element={<Home2Page />} />
      {/* ... etc. */}
    </Route>
  )
);

export default router